import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AvaliacaoService extends ServerService {
  // Selo do topo: aparece no topo do celular e no do desktop, uma busca só por carga da loja.
  private resumoPublico: Promise<any>;

  constructor(private httpCliente: HttpClient) {
    super(httpCliente);
  }

  envie(avaliacao: any, pedido: any) {
    return this.facaPost(`/avaliacoes/envie`, {
      avaliacao: avaliacao,
      pedido: {
        guid: pedido.guid
      }
    });
  }

  obtenhaPorPedido(pedido: any) {
    return this.obtenha(`/avaliacoes/obtenha/` + pedido.guid, {
    });
  }

  listePublicas(inicio: number, total: number) {
    return this.obtenha('/avaliacoes/publicas', {i: inicio, t: total});
  }

  obtenhaResumoPublico() {
    if (!this.resumoPublico)
      this.resumoPublico = this.listePublicas(0, 1).catch(() => ({media: 0, total: 0}));

    return this.resumoPublico;
  }
}
